import { NomadDB } from '~/db/NomadDB.js';
import type { FavoriteSchema } from '@/types/schema';

export const getFavoritesService = (db: NomadDB) => {
  const findAll = async (): Promise<FavoriteSchema[]> => {
    return await db.favorites.toArray();
  };

  const bulkPut = async (favorites: FavoriteSchema[]): Promise<void> => {
    try {
      await db.favorites.bulkPut(favorites);
    } catch (e) {
      console.error(e);
    }
  };

  return {
    findAll,
    bulkPut,
  };
};
